import lightbox from "../../assets/.npm/node_modules/lightbox2/dist/js/lightbox";
import Swiper from "../../assets/.npm/node_modules/swiper";
import Navigation from "../../assets/.npm/node_modules/swiper/modules/navigation.min.mjs";
import Pagination from "../../assets/.npm/node_modules/swiper/modules/pagination.min.mjs";

export default () => {
  window.lightbox = lightbox;
  window.lightbox.option({
    //'resizeDuration': 400,
    wrapAround: true,
  });

  const swiperGallery = new Swiper(".slider-gallery", {
    modules: [Navigation, Pagination],
    slidesPerView: 1.5,
    loop: true,
    centeredSlides: false,
    spaceBetween: 20,
    navigation: {
      nextEl: ".gallery-next",
      prevEl: ".gallery-prev",
    },
    pagination: {
      el: ".gallery-pagination",
      clickable: true,
    },
    breakpoints: {
      580: {
        slidesPerView: 2.5,
        spaceBetween: 20,
        centeredSlides: true,
      },
      992: {
        slidesPerView: 4.2,
        centeredSlides: true,
      },
    },
  });
};
